import { PriceConstructionTypeRelationStatusEnum } from 'gql/graphql';
import { cnMixSpace, IconConnection, Tooltip } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';
import type { CSSProperties } from 'react';
import React, { useCallback, useMemo, useRef, useState } from 'react';

import type { RowData } from '../types';

const WrapperStyle: CSSProperties = { display: 'flex', alignItems: 'center', flexWrap: 'nowrap' };
const IconStyle: CSSProperties = { flexShrink: 0 };

interface IUerUnitCostWithOtherCellRendererComponent extends ICellRendererParams<RowData> {
    constructionTypeId: number;
    isExpanded: boolean;
}

export const UerUnitCostWithOtherCellRendererComponent = ({
    valueFormatted,
    constructionTypeId,
    data,
    isExpanded,
}: IUerUnitCostWithOtherCellRendererComponent) => {
    const ref = useRef<HTMLSpanElement>(null);
    const [isIconHovered, setIsIconHovered] = useState<boolean>(false);

    const handleMouseMoveIcon = useCallback(() => {
        setIsIconHovered(true);
    }, []);

    const handleMouseLeaveIcon = useCallback(() => setIsIconHovered(false), []);

    const currentPrice = useMemo(
        () => data?.currentPrices?.find(({ constructionTypeId: id }) => constructionTypeId === id),
        [constructionTypeId, data?.currentPrices],
    );

    return (
        <div style={WrapperStyle}>
            {valueFormatted !== '' &&
                !isExpanded &&
                currentPrice?.constructionTypeRelationStatus === PriceConstructionTypeRelationStatusEnum.NewRecord && (
                    <>
                        <IconConnection
                            key={`${data?.id}${constructionTypeId}`}
                            size="s"
                            view="link"
                            className={cnMixSpace({ mR: 'xs' })}
                            style={IconStyle}
                            ref={ref}
                            onMouseMove={handleMouseMoveIcon}
                            onMouseLeave={handleMouseLeaveIcon}
                        />

                        {isIconHovered && (
                            <Tooltip size="m" direction="upCenter" anchorRef={ref} isInteractive={false}>
                                Новая связь
                            </Tooltip>
                        )}
                    </>
                )}
            {valueFormatted}
        </div>
    );
};

UerUnitCostWithOtherCellRendererComponent.displayName = 'UerUnitCostWithOtherCellRendererComponent';
